// extracted by mini-css-extract-plugin
export default {"create":"styles_create__Hm1F6","row":"styles_row__QqzRw","col":"styles_col__fcbRp","flexRight":"styles_flexRight__sAVfX"};